import {Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

@Component({
  selector: 'alg-button',
  templateUrl: './alg-button.component.html',
  styleUrls: ['./alg-button.component.scss']
})
export class AlgButtonComponent implements OnInit {
  @Input() title: string = '';
  @Input() id: string = '';
  @Input() outline: boolean = false;
  @Input() variant: any;
  @Input() full: boolean = false;
  @Input() disabled: boolean = false;
  @Input() type: string;

  public buttonClasses: any = {};
  constructor() { }

  ngOnInit() {
    this.buttonClasses[this.variant] = true;
    this.buttonClasses['outline'] = this.outline;
    this.buttonClasses['full'] = this.full;
  }
  ngOnChanges(changes: SimpleChanges) {
    if(changes.variant){
      this.buttonClasses[changes.variant.previousValue] = false;
      this.buttonClasses[changes.variant.currentValue] = true;
    }
    if(changes.outline){
      this.buttonClasses['outline'] = changes.outline.currentValue;
    }
    if(changes.full){
      this.buttonClasses['full'] = changes.full.currentValue;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/atoms/alg-button/alg-button.component.ts